import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { TreeTable } from "primereact/treetable";

const atributosHeader = ({ selectedFamiliaData, onAgregarAtributo }) => {
    const idPadre = selectedFamiliaData?.raw?.id_padre;
    const isHijo = !!selectedFamiliaData?.raw && idPadre > 0;
    const bloqueaPorRaiz = !!selectedFamiliaData && !isHijo;
    return (
    <div className="flex align-items-center justify-content-between">
        <span className="font-semibold">
            {selectedFamiliaData ? `Atributos de ${selectedFamiliaData.name}` : "Selecciona una familia"}
        </span>
        <Button
            icon="pi pi-plus"
            label="Agregar"
            onClick={onAgregarAtributo}
            disabled={!selectedFamiliaData || bloqueaPorRaiz}
            severity="success"
            tooltip={bloqueaPorRaiz ? "La familia raíz no puede agregar atributos" : undefined}
            tooltipOptions={{ position: "top" }}
            size="small"
        />
    </div>
    );
};

const FamiliaAtributosPanel = ({
    selectedFamiliaData,
    atributos,
    loadingAtributos,
    onEditarAtributo,
    onAgregarAtributo,
    onEliminarAtributo,
    onAbrirValores,
}) => {
    if (!selectedFamiliaData) {
        return (
            <div className="col-12 lg:col-4">
                <div className="card text-center py-6">
                    <i className="pi pi-sitemap text-500 text-4xl mb-3" />
                    <p className="text-500 m-0">Selecciona una familia para ver sus atributos</p>
                </div>
            </div>
        );
    }

    const treeNodes = atributos.map((attr, i) => ({
        key: String(i),
        data: {
            id: attr.id,
            llave: attr.llave || "",
            tipoDato: attr.tipoDato || "",
        },
    }));

    const actionBody = (rowData) => (
        <div className="flex gap-1 align-items-center">
            <Button
                icon="pi pi-pencil"
                tooltip="Editar atributo"
                tooltipOptions={{ position: "top" }}
                onClick={() => onEditarAtributo?.(rowData.data)}
                severity="primary"
                outlined
                size="small"
            />
            <Button
                icon="pi pi-tags"
                tooltip="Administrar valores"
                tooltipOptions={{ position: "top" }}
                onClick={() => onAbrirValores?.(rowData.data)}
                severity="info"
                outlined
                size="small"
            />
            <Button
                icon="pi pi-trash"
                tooltip="Eliminar atributo"
                tooltipOptions={{ position: "top" }}
                onClick={() => onEliminarAtributo?.(rowData.data)}
                severity="danger"
                outlined
                size="small"
            />
        </div>
    );

    return (
        <div className="col-12 lg:col-5">
            <div className="card">
                <TreeTable
                    value={treeNodes}
                    header={atributosHeader({ selectedFamiliaData, onAgregarAtributo })}
                    paginator
                    rows={10}
                    loading={loadingAtributos}
                    emptyMessage="No hay atributos para esta familia"
                >
                    <Column field="llave" header="Descripción" expander />
                    <Column field="tipoDato" header="Tipo" style={{ width: "20%" }} />
                    <Column body={actionBody} header="" style={{ width: "25%" }} />
                </TreeTable>
            </div>
        </div>
    );
};

export default FamiliaAtributosPanel;